import { Injectable, WritableSignal, signal } from '@angular/core';
import { AiqDialogData } from './aiq.model';

@Injectable({ providedIn: 'root' })
export class AiqDialogService {
    private questions: WritableSignal<Array<AiqDialogData>> = signal([
        {
            question: 'Write your own question.',
        },
    ]);

    getQuestions(): Array<AiqDialogData> {
        return this.questions();
    }
}
